<!-- ingen [formGroup] da siden kun inneholder én formControl -->
<form (ngSubmit)="registrer()" class="e2e-kommentar-svarskjema">

  <mat-form-field class="mat-form-field-dense-3" appearance="outline">
    <textarea matInput
              [formControl]="skjema"
              (keydown.esc)="avbryt()"
              placeholder="{{ 'Ditt svar'|translate }}"
              class="e2e-kommentar-tekstfelt"
              cdkTextareaAutosize
              tilpassAutosizeVedBreddeendring
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="10"
              #svarfelt></textarea>
    @if (skjema.hasError('maxlength')) {
      <mat-error data-testid="maxlength">{{ skjema.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
    }
  </mat-form-field>

    <div class="handlinger" [style.visibility]="visFulltSkjema() ? 'visible' : 'hidden'">
      <button mat-button color="primary" type="submit" [disabled]="skjema.invalid || lagrer()" [visSpinner]="lagrer()" class="e2e-registrer-svar">
        {{ "Registrer" | translate }}
      </button>
      <button mat-icon-button (click)="avbryt()" class="mat-medium-icon-button">
        <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
      </button>
    </div>

</form>


